import "core-js/modules/es.array.push.js";
import DashboardTabs from '@/components/DashboardTabs.vue';
import SysConfigTabs from '@/components/config/SysConfigTabs.vue';
import SysCogStatus from '@/components/config/SysCogStatus.vue';
import SysCogUpload from '@/components/config/SysCogUpload.vue';
import SysCogSecurity from '@/components/config/SysCogSecurity.vue';
import SysCogPage from '@/components/config/SysCogPage.vue';
import SysCogOthers from '@/components/config/SysCogOthers.vue';
import backgroundManager from '@/mixins/backgroundManager';
export default {
  name: 'SystemConfig',
  mixins: [backgroundManager],
  data() {
    return {
      activeIndex: 'status',
      isSidebarCollapse: false
    };
  },
  watch: {
    // 监听锚点变化
    '$route.hash': {
      immediate: true,
      handler(newHash) {
        this.activeIndex = newHash.replace('#', '');
        window.scrollTo(0, 0); // 滚动到页面顶部
      }
    },
    activeIndex(newIndex) {
      // 更新锚点
      const hash = `#${newIndex}`;
      this.$router.push({
        hash
      });
    }
  },
  components: {
    DashboardTabs,
    SysConfigTabs,
    SysCogStatus,
    SysCogUpload,
    SysCogSecurity,
    SysCogPage,
    SysCogOthers
  },
  computed: {
    disableTooltip() {
      return window.innerWidth < 768;
    },
    // 根据锚点动态返回对应的组件
    currentComponent() {
      const hash = this.$route.hash.replace('#', '');
      switch (hash) {
        case 'status':
          return SysCogStatus;
        case 'upload':
          return SysCogUpload;
        case 'security':
          return SysCogSecurity;
        case 'page':
          return SysCogPage;
        case 'others':
          return SysCogOthers;
        default:
          return SysCogStatus;
      }
    }
  },
  methods: {
    handleLogout() {
      const url = process.env.NODE_ENV === 'production' ? '/api/auth/logout' : '/api/api/auth/logout';
      fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          authType: 'admin'
        })
      }).finally(() => {
        this.$store.commit('setAdminLoggedIn', false);
        this.$router.push('/adminLogin');
      });
    },
    // 设置默认锚点
    setDefaultHash() {
      const defaultHash = '#status'; // 默认锚点
      window.location.hash = defaultHash;
      this.activeIndex = defaultHash.replace('#', '');
    }
  },
  mounted() {
    // 初始化背景图
    this.initializeBackground('adminBkImg', '.container', false, true);

    // 如果 URL 中没有锚点，则设置默认锚点
    if (!window.location.hash) {
      this.setDefaultHash();
    }
  }
};